import { calcularDiasCalendario } from "../../../utils/DateUtils";
import { isEmptyValue } from "../../../utils/StringUtil";
import { COBERTURA_VALIDACION } from "./IngresoConstant";
import { camposCompletos } from "../../../utils/ValidationUtil";
import { dataTipoServicioCierreCuentas } from "../../../utils/LocalData";

export const obtenerObjetoIngreso = (numeroIngreso) => {
  if (numeroIngreso?.length < 8) {
    return null;
  }

  return {
    ano: numeroIngreso.slice(0, 4),
    compania: numeroIngreso.slice(4, 6),
    ramo: numeroIngreso.slice(6, 8),
    secuencial: numeroIngreso.slice(8),
  };
};

export const obtenerObjetoPoliza = (numeroPoliza) => {
  const parts = numeroPoliza.split("-");

  if (parts.length !== 3) {
    return null;
  }

  return {
    compania: parts[0],
    ramo: parts[1],
    secuencial: parts[2],
  };
};

export const obtenerFrecuenciaValida = (
  frecuencia,
  cobertura,
  fechaServicio,
  fechaSalida
) => {
  let frecuenciaValiada = frecuencia;

  if (Number(cobertura) === COBERTURA_VALIDACION.HABITACION_DIARIA) {
    const dias = calcularDiasCalendario(fechaServicio, fechaSalida);
    if(!dias || Number(dias) === 0){
      frecuenciaValiada = 1;
    }else{
      frecuenciaValiada = dias;
    }
  }

  if (isEmptyValue(frecuenciaValiada) || Number(frecuenciaValiada) === 0) {
    frecuenciaValiada = 1;
  }

  return frecuenciaValiada;
};

export const obtenerSiguienteSecuencia = (procedimientos) => {
  if (!Array.isArray(procedimientos) || procedimientos?.length === 0) return 1;
  const maxSecuencia = Math.max(...procedimientos?.map((item) => item.secuencia));
  return maxSecuencia + 1;
};

export const camposRequeridosCompletos = (formData) => {
  const {
    fechaSalida,
    motivoEgreso,
    causaInternamiento,
    fechaServicio,
    tipoServicio,
  } = formData;

  return camposCompletos({
    fechaSalida,
    motivoEgreso,
    causaInternamiento,
    fechaServicio,
    tipoServicio,
  });
};

export const obtenerTiposServicio = (
  tienePrecertificacion,
  aplicaExcepcion
) => {
  const conPrecertificacionSinExcepcion = [
    {
      key: 1,
      label: "Ambulatorio",
      value: "1",
    },
    {
      key: 2,
      label: "Hospitalización",
      value: "2",
    },
  ];

  const conPrecertificacionConExcepcion = [
    {
      key: 1,
      label: "Ambulatorio",
      value: "1",
    },
    {
      key: 2,
      label: "Hospitalización",
      value: "2",
    },
    {
      key: 11,
      label: "Parto",
      value: "11",
    },
    {
      key: 12,
      label: "Cesárea",
      value: "12",
    },
  ];

  const sinPrecertificacionSinExcepcion = [
    {
      key: 2,
      label: "Hospitalización",
      value: "2",
    },
    {
      key: 5,
      label: "Maternidad",
      value: "5",
    },
  ];

  const sinPrecertificacionConExcepcion = [
    {
      key: 2,
      label: "Hospitalización",
      value: "2",
    },
    {
      key: 5,
      label: "Maternidad",
      value: "5",
    },
    {
      key: 11,
      label: "Parto",
      value: "11",
    },
    {
      key: 12,
      label: "Cesárea",
      value: "12",
    },
  ];

  const servicioMap = {
    "true-false": conPrecertificacionSinExcepcion,
    "true-true": conPrecertificacionConExcepcion,
    "false-true": sinPrecertificacionSinExcepcion,
    "false-false": sinPrecertificacionConExcepcion,
  };

  return (
    servicioMap[`${tienePrecertificacion}-${aplicaExcepcion}`] ||
    dataTipoServicioCierreCuentas
  );
};
